<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        {{ formTitle }} SKU Variant
        <span v-if="this.$route.params.id > 0">-</span> {{ variant_sku }}
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-dialog v-model="dialog" max-width="400" max-height="500">
      <v-card>
        <v-card-title class="card-title">
          Mapped Images- {{ selectedItem.variant_sku_code }}-({{
            selectedItem.sku_code
          }})
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-carousel
            cycle
            hide-delimiters
            interval="5000"
            show-arrows-on-hover
            height="200"
            v-if="images && images.length > 1"
          >
            <v-carousel-item
              v-for="(image, index) in images"
              :key="index"
              :src="image"
              max-height="200"
              class="carousel-image"
              contain
            ></v-carousel-item>
          </v-carousel>
          <v-img v-else :src="images[0]"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template>
      <v-card>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-row class="text-center py-0">
              <v-col
                cols="12"
                sm="6"
                class="pb-0"
                v-if="
                  (userCategory.user_category === 3 ||
                    userCategory.user_category === 6) &&
                  this.$route.params.id == 0
                "
              >
                <v-autocomplete
                  v-model="client"
                  :items="clients"
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  class="required pb-0"
                  @focus="fetchClientList"
                  dense
                  @change="getStores(client)"
                  :rules="[(v) => !!v || 'Client is required.']"
                  outlined
                  :readonly="$route.params.id > 0"
                ></v-autocomplete>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                md="6"
                class="pb-0"
                v-if="
                  (userCategory.user_category === 3 ||
                    userCategory.user_category === 6) &&
                  $route.params.id > 0
                "
              >
                <v-text-field
                  label="Client"
                  v-model="client_name"
                  dense
                  readonly
                  outlined
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="pb-0"
                v-if="$route.params.id == 0"
              >
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  :rules="[(v) => !!v || 'Storer Name is required.']"
                  item-text="channel_name"
                  item-value="id"
                  class="required"
                  dense
                  :items="stores"
                  @change="getSkuDropDownList"
                  outlined
                  :readonly="$route.params.id > 0"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="pb-0"
                v-if="$route.params.id > 0"
              >
                <v-text-field
                  label="Storer Name"
                  v-model="storer_name"
                  dense
                  readonly
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0" v-if="$route.params.id == 0">
                <v-autocomplete
                  v-model="sku"
                  :items="skuList"
                  item-text="sku_code"
                  item-value="id"
                  dense
                  label="Select Sku"
                  class="required pb-0"
                  :rules="[(v) => !!v || 'Sku is required.']"
                  outlined
                  @change="getlist"
                  :loading="skuloader"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0" v-if="$route.params.id > 0">
                <v-text-field
                  label="SKU"
                  v-model="sku_code"
                  dense
                  readonly
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-divider
            class="mb-2"
            v-if="resultChild.length > 0 || openform"
          ></v-divider>
          <v-data-table
            :headers="headersChild"
            :items="resultChild"
            class="elevation-1 custom-icon-size mb-4 mr-4"
            :loading="loader"
            disable-pagination
            hide-default-footer
            v-if="resultChild.length > 0 || openform"
          >
            <template v-slot:[`item.variant_sku_code`]="{ item }">
              <v-icon v-if="item.sku_type == 1" color="success"
                >mdi-barcode</v-icon
              >
              <v-icon v-if="item.sku_type == 0" color="primary"
                >mdi-book-variant</v-icon
              >{{ item.variant_sku_code }}
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              <span v-if="item.created_at"
                >{{
                  item.created_at
                    | localMomentNew
                    | moment("DD MMM, YYYY hh:mm A")
                }}<br />{{ item.created_by }}</span
              >
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
              <span v-if="item.updated_at"
                >{{
                  item.updated_at
                    | localMomentNew
                    | moment("DD MMM, YYYY hh:mm A")
                }}<br />{{ item.updated_by }}</span
              >
            </template>
            <template v-slot:[`item.variant_sku_description`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    v-if="item.variant_sku_description.length > 80"
                    v-on="on"
                    >{{
                      item.variant_sku_description.slice(0, 80) + "..."
                    }}</span
                  >
                  <span v-else>{{ item.variant_sku_description }}</span>
                </template>
                <span>{{ item.variant_sku_description }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.variant`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    v-if="item.variant && item.variant.length > 80"
                    v-on="on"
                    >{{ item.variant.slice(0, 80) + "..." }}</span
                  >
                  <span v-else-if="item.variant">{{ item.variant }}</span>
                </template>
                <span v-if="item.variant">{{ item.variant }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.size`]="{ item }">
              {{
                (item.size ? item.size : "-") +
                " / " +
                (item.design ? item.design : "-") +
                " / " +
                (item.aroma ? item.aroma : "-")
              }}
            </template>
            <template v-slot:[`item.volume`]="{ item }">
              {{
                (item.volume ? item.volume : "-") +
                " / " +
                (item.variant ? item.variant : "-")
              }}
            </template>
            <template v-slot:[`item.dimension`]="{ item }">
              {{
                (item.width ? item.width : "-") +
                " x " +
                (item.height ? item.height : "-") +
                " x " +
                (item.length ? item.length : "-")
              }}
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                class="ma-1"
                :color="item.status == 1 ? 'green' : 'red'"
                text-color="white"
              >
                {{ item.status == 1 ? "Active" : "Inactive" }}
              </v-chip>
            </template>
            <template v-slot:item.variant_sku_mapping_status="{ item }">
              <v-chip
                class="ma-1"
                :color="item.variant_sku_mapping_status == 2 ? 'green' : 'red'"
                text-color="white"
              >
                {{
                  item.variant_sku_mapping_status == 2
                    ? "Completed"
                    : "In Progress"
                }}
              </v-chip>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-btn icon @click="imagesFunction(item)" v-if="checkIcon(item)">
                <v-icon>mdi-image</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <v-form
            ref="form1"
            class="mr-4"
            lazy-validation
            v-if="resultChild.length > 0 || openform"
          >
            <v-row class="py-0">
              <v-col
                cols="12"
                sm="6"
                class="pb-0"
                v-if="resultChild.length == 0 || resultChild[0].sku_type == 1"
              >
                <v-autocomplete
                  v-model="sku_type"
                  dense
                  :items="types"
                  label="SKU Type"
                  class="pb-0"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                class="pb-0"
                v-if="sku_type == 'Add an existing Barcode'"
              >
                <v-text-field
                  v-model="barcode"
                  dense
                  :items="types"
                  label="Barcode"
                  class="pb-0 required"
                  :rules="[(v) => !!v || 'Barcode is required.']"
                  outlined
                ></v-text-field> </v-col
            ></v-row>
            <v-row class="py-0">
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  v-model="size"
                  dense
                  label="Size"
                  class="pb-0"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  v-model="design"
                  dense
                  label="Design"
                  class="pb-0"
                  outlined
                  maxlength="25"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  v-model="aroma"
                  dense
                  label="Aroma"
                  class="pb-0"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  v-model="volume"
                  label="Volume"
                  dense
                  class="pb-0"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  v-model="variant"
                  label="Variant"
                  dense
                  class="pb-0"
                  outlined
                  maxlength="255"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-autocomplete
                  v-model="color"
                  outlined
                  dense
                  :items="colors"
                  label="Color"
                  multiple
                  clearable
                  class="pb-0"
                  hide-details
                  deletable-chips
                  item-text="name"
                  item-value="name"
                  :search-input.sync="search"
                  @input="handleInput"
                >
                  <template v-slot:selection="{ item }">
                    <v-avatar
                      size="16"
                      :style="{
                        'background-color': item.hex,
                        'margin-right': '5px',
                        'margin-left': '5px',
                        'border-radius': '2px',
                      }"
                    >
                    </v-avatar>
                    {{ item.name }}
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-avatar>
                      <v-avatar
                        size="22"
                        :style="{
                          'background-color': item.hex,
                        }"
                      ></v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span :style="{ background: item.hex }"></span>
                        {{ item.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="2" class="pb-0">
                <v-text-field
                  v-model="width"
                  label="Width (In cm)"
                  class="pb-0"
                  outlined
                  dense
                  :rules="[
                    (v) =>
                      v === null ||
                      v === '' ||
                      /^([1-9]\d*|0)(\.\d{1,2})?$/.test(v) ||
                      'Postive number and maximum of 2 decimal points are allowed ',
                  ]"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="2" class="pb-0">
                <v-text-field
                  v-model="height"
                  label="Height (In cm)"
                  class="pb-0"
                  outlined
                  dense
                  :rules="[
                    (v) =>
                      v === null ||
                      v === '' ||
                      /^([1-9]\d*|0)(\.\d{1,2})?$/.test(v) ||
                      'Postive number and maximum of 2 decimal points are allowed ',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" class="pb-0">
                <v-text-field
                  v-model="length"
                  label="Length (In cm)"
                  class="pb-0"
                  outlined
                  dense
                  :rules="[
                    (v) =>
                      v === null ||
                      v === '' ||
                      /^([1-9]\d*|0)(\.\d{1,2})?$/.test(v) ||
                      'Postive number and maximum of 2 decimal points are allowed ',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  v-model="weight"
                  label="Weight (In gm)"
                  class="pb-0"
                  dense
                  :rules="[
                    (v) =>
                      v === null ||
                      v === '' ||
                      /^([1-9]\d*|0)(\.\d{1,2})?$/.test(v) ||
                      'Postive number and maximum of 2 decimal points are allowed ',
                  ]"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" class="pb-0">
                <v-text-field
                  v-model="description"
                  label="Description"
                  class="pb-0 required"
                  dense
                  :rules="[
                    (v) =>
                      (v && v.length <= 50) ||
                      'Description is required and should not be more than 50 characters.',
                  ]"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="12"
                class="pb-0 pt-0 pr-0"
                v-if="$route.params.id > 0"
              >
                <span>
                  <b>SKU Description: </b>
                  <span :style="{ color: parentdescription ? 'blue' : '' }">{{
                    parentdescription
                  }}</span>
                </span>
              </v-col>
              <v-col cols="12" sm="12" class="pb-0 pt-0 pr-0">
                <span>
                  <b>SKU Variant Description: </b>
                  <span :style="{ color: description ? 'blue' : '' }">{{
                    description
                  }}</span>

                  <span
                    :style="{
                      color: this.color.join('-').length > 0 ? 'blue' : '',
                    }"
                  >
                    <span v-if="this.color.join('-').length > 0">-</span
                    >{{ this.color.join("-") }}</span
                  >

                  <span :style="{ color: this.design ? 'blue' : '' }"
                    ><span v-if="this.design">-</span>{{ this.design }}</span
                  >

                  <span :style="{ color: this.size ? 'blue' : '' }"
                    ><span v-if="this.size">-</span>{{ this.size }}</span
                  >

                  <span :style="{ color: this.aroma ? 'blue' : '' }"
                    ><span v-if="this.aroma">-</span>{{ this.aroma }}</span
                  >

                  <span :style="{ color: this.volume ? 'blue' : '' }"
                    ><span v-if="this.volume">-</span>{{ this.volume }}</span
                  >

                  <span :style="{ color: this.variant ? 'blue' : '' }"
                    ><span v-if="this.variant">-</span>{{ this.variant }}</span
                  >
                </span>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-autocomplete
                  v-model="status"
                  label="Status"
                  :items="statuses"
                  item-text="name"
                  dense
                  item-value="value"
                  class="pb-0 required"
                  outlined
                  :rules="[
                    (v) => {
                      if (v == null || v === '') {
                        return 'Value is required.';
                      } else {
                        return true;
                      }
                    },
                  ]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-file-input
                  v-model="imagesUpload"
                  label="Upload Images"
                  accept=".png,.jpeg,.jpg"
                  multiple
                  prepend-icon=""
                  dense
                  prepend-inner-icon="mdi-camera"
                  @change="onFilesChange"
                  outlined
                  class="custom-file-input"
                  :rules="[
                    (v) =>
                      !v ||
                      v.every((file) =>
                        /image\/(jpeg|jpg|png)/.test(file.type)
                      ) ||
                      'Only jpg, jpeg and png images are allowed.',
                  ]"
                ></v-file-input>
              </v-col>

              <v-row v-if="imageUrls.length" class="pl-4">
                <v-col
                  v-for="(url, index) in imageUrls"
                  :key="index"
                  cols="12"
                  md="12"
                  lg="4"
                  sm="12"
                  class="d-flex align-center"
                >
                  <v-img
                    :src="url"
                    max-width="300"
                    class="my-4"
                    max-height="300"
                  ></v-img>
                  <v-btn
                    color="error"
                    icon
                    small
                    class="ml-0 pl-0"
                    @click="deleteImage(index)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-col cols="12" sm="12" class="pt-0 text-left">
                <v-btn
                  class="primary"
                  @click="saveForm('nomore')"
                  :loading="downloader"
                  v-if="
                    $route.params.id == 0 &&
                    checkPermission('app_sku_variant:b2b_sku_variant_create')
                  "
                  >Add</v-btn
                >
                <v-btn
                  class="primary ml-4"
                  @click="saveForm('more')"
                  :loading="downloader"
                  v-if="
                    $route.params.id == 0 &&
                    checkPermission('app_sku_variant:b2b_sku_variant_create')
                  "
                  >Add More</v-btn
                >
                <v-btn
                  class="success"
                  @click="saveForm()"
                  :loading="downloader"
                  v-if="
                    $route.params.id > 0 &&
                    checkPermission('app_sku_variant:b2b_sku_variant_update')
                  "
                  >Update</v-btn
                >
                <v-btn color="white" class="ml-4" @click="reset()"
                  >Cancel</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </template>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  created() {
    if (this.$store.getters.user.user_category == 1) {
      this.client = this.$store.getters.user.id;
      this.getStores(this.client);
    } else {
      this.fetchClientList();
    }
    if (this.$route.params.id > 0) {
      this.getSkuEditData(this.$route.params.id).then((res) => {
        if (res.data.parent_details.length)
          this.variant_sku = res.data.records.variant_sku_code;
        this.sku_code = res.data.parent_details[0].sku_code;
        this.client_name = res.data.records.client_name;
        this.storer_name = res.data.records.storer_name;
        this.sku = res.data.records.sku_code;
        this.infor_storer_id = res.data.records.storer_id;

        this.client = res.data.records.client_id;
        this.getlist();
        this.size = res.data.records.size || "";
        this.design = res.data.records.design || "";
        this.volume = res.data.records.volume || "";
        this.aroma = res.data.records.aroma || "";
        this.color = [];
        this.width = res.data.records.width || "";
        this.height = res.data.records.height || "";
        this.length = res.data.records.length || "";
        this.status =
          typeof res.data.records.status === "string"
            ? Number(res.data.records.status)
            : res.data.records.status;

        this.variant = res.data.records.variant || "";
        if (res.data.records.sku_type == 1) {
          this.sku_type = "Add an existing Barcode";
          this.barcode = res.data.records.variant_sku_code;
        }
        this.color = res.data.records.color
          ? res.data.records.color.split(",")
          : [];

        this.description = res.data.records.sku_description;
        if (this.description == null) {
          this.description = res.data.parent_details[0].sku_description;
        }
        this.parentdescription = res.data.parent_details[0].sku_description;
        (this.imagesUpload = []), (this.weight = res.data.records.weight);
      });
    }
  },
  computed: {
    formTitle() {
      return this.$route.params.id > 0 ? "Edit" : "Add";
    },
    ...mapGetters(["userRole", "userCategory"]),
    // maxSelectionRule() {
    //   return (color) => {
    //     if (Array.isArray(color) && color.length > 3) {
    //       return "You can only select up to 3 colors";
    //     }
    //     return true;
    //   };
    // },
  },

  data: () => ({
    sku_type: "",
    barcode: "",
    dialog: false,
    active: false,
    selectedColor: "",
    selectedColorName: "",
    sku: "",
    clients: [],
    client: null,
    skuList: [],
    stores: [],
    variant: "",
    client_name: "",
    storer_name: "",
    types: ["Add an existing Barcode", "Generate a Variant"],
    headersChild: [
      {
        text: "SKU Variant/Barcode Code",
        value: "variant_sku_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "SKU Variant/Barcode Description",
        value: "variant_sku_description",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "200px",
      },
      {
        text: "Size / Design / Aroma",
        value: "size",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Volume / Variant",
        value: "volume",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "Color",
        value: "color",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "W x H x L (In cm)",
        value: "dimension",
        sortable: false,
        class: "body-1 font-weight-bold",
        width: "200px",
      },

      {
        text: "Weight (In gm)",
        value: "weight",
        sortable: false,
        class: "body-1 font-weight-bold",
      },

      {
        text: "Status",
        value: "status",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "Created At (By)",
        value: "created_at",
        sortable: false,
        class: "body-1 font-weight-bold",
        width: 120,
      },

      {
        text: "Updated At (By)",
        value: "updated_at",
        sortable: false,
        class: "body-1 font-weight-bold",
        width: 120,
      },

      {
        text: "Action",
        value: "action",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
    ],
    statuses: [
      {
        name: "Active",
        value: 1,
      },
      {
        name: "InActive",
        value: 0,
      },
    ],
    size: "",
    design: "",
    volume: "",
    aroma: "",
    color: [],
    width: "",
    height: "",
    length: "",
    status: "",
    images: [],
    imagesUpload: [],
    parentdescription: "",
    weight: "",
    infor_storer_id: "",
    imageUrls: [],
    search: "",
    colors: [
      {
        hex: "#000000",
        name: "Black",
      },
      {
        hex: "#FFFFFF",
        name: "White",
      },
      {
        hex: "#808080",
        name: "Gray",
      },
      {
        hex: "#E5E4E2",
        name: "Silver",
      },
      {
        hex: "#ADD8E6",
        name: "Light Blue",
      },

      {
        hex: "#0000FF",
        name: "Blue",
      },
      {
        hex: "#0000B8",
        name: "Dark Blue",
      },

      {
        hex: "#D0F0C0",
        name: "Light Green",
      },
      {
        hex: "#00FF00",
        name: "Green",
      },
      {
        hex: "#013220",
        name: "Dark Green",
      },
      {
        hex: "#FFFF00",
        name: "Yellow",
      },

      {
        hex: "#FFD700",
        name: "Gold",
      },
      {
        hex: "#FFA000",
        name: "Orange",
      },
      {
        hex: "#F5F5DC",
        name: "Beige",
      },
      {
        hex: "#804000",
        name: "Brown",
      },
      {
        hex: "#4A412A",
        name: "Dark Brown",
      },

      {
        hex: "#FFC0CB",
        name: "Light Pink",
      },
      {
        hex: "#DBB2D1",
        name: "Pink",
      },
      {
        hex: "#FC0FC0",
        name: "Dark Pink",
      },
      {
        hex: "#8F00FF",
        name: "Light Purple",
      },
      {
        hex: "#800080",
        name: "Purple",
      },
      {
        hex: "#FF0000",
        name: "Red",
      },
      {
        hex: "#800000",
        name: "Maroon",
      },

      {
        hex: "",
        name: "Multicolor",
      },
    ],
    resultChild: [],
    result: [],
    selectedItem: {},
    description: "",
    sku_code: "",
    openform: false,
    skuloader: false,
  }),

  watch: {
    options: {
      handler() {},
      deep: true,
    },
  },

  methods: {
    ...mapActions([
      "snackBar",
      "getPriceRateList",
      "fetchClient",
      "uploadSkuBB",
      "updateSkuBB",
      "getSkuDropDown",
      "getInforStoreList",
      "getChannelDropdownBB",
      "getSkuListSearch",
      "getSkuImages",
      "getSkuListBB",
      "getSkuEditData",
    ]),

    getlist() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.result = [];
      this.resultChild = [];
      this.searchButton = false;
      this.loader = true;
      this.getSkuListBB({
        b2b_sku_code: this.sku ? this.sku.trim() : this.sku,
        storer_id: this.infor_storer_id,
        client_id: this.client,
        pagination: 0,
      })
        .then((res) => {
          this.result = res.data.records1;
          this.resultChild = res.data.records;
          if (res.data.records == 0) {
            this.openform = true;
          }
          this.image_mapping = res.data.image_mapping;
          this.total = res.data.total;
          this.loader = false;
          this.skuList.forEach((item) => {
            if (item.id == this.sku) {
              this.description = item.sku_description;
            }
          });
        })

        .catch(() => {
          this.loader = false;
        });
      if (this.$refs.form1) {
        this.$refs.form1.reset();
      }
    },

    handleInput() {
      this.search = "";
    },
    getStores(id) {
      this.infor_storer_id = "";
      this.stores = [];
      this.getChannelDropdownBB(id).then((res) => {
        this.stores = res.data;
      });
      this.skuList = [];
      if (this.$refs.form1) {
        this.$refs.form1.reset();
      }
      this.result = [];
      this.resultChild = [];
    },
    onFilesChange() {
      // this.imageUrls = [];
      if (this.imagesUpload && this.imagesUpload.length) {
        this.imagesUpload.forEach((file) => {
          this.imageUrls.push(URL.createObjectURL(file));
        });
      }
    },
    deleteImage(index) {
      +this.imageUrls.splice(index, 1);
      +this.images.splice(index, 1);
    },
    getSkuDropDownList() {
      if (this.client) {
        this.skuloader = true;
        this.getSkuDropDown({
          client_id: this.client,
          storer_id: this.infor_storer_id,
        })
          .then((res) => {
            this.skuList = res.data.sku;
            this.skuloader = false;
          })
          .catch(() => {
            this.skuloader = false;
          });
      }
    },
    imagesFunction(item) {
      this.selectedItem = item;
      let payload = {
        sku_variant_id: item.id,
        client_id: item.client_id,
      };
      this.getSkuImages(payload).then((res) => {
        if (res.data) {
          this.images = res.data.result;
          this.dialog = true;
        }
      });
    },
    saveForm(from) {
      if (this.$refs.form1.validate()) {
        var formData = new FormData();
        formData.append("client_id", this.client);
        formData.append("b2b_sku_id", this.sku);
        formData.append("size", this.size === null ? "" : this.size);
        formData.append("design", this.design === null ? "" : this.design);
        formData.append("aroma", this.aroma === null ? "" : this.aroma);
        formData.append("volume", this.volume === null ? "" : this.volume);
        formData.append("status", this.status);
        formData.append("color", this.color === null ? "" : this.color);
        formData.append("width", this.width === null ? "" : this.width);
        formData.append("height", this.height === null ? "" : this.height);
        formData.append("length", this.length === null ? "" : this.length);
        formData.append("weight", this.weight === null ? "" : this.weight);
        formData.append("storer_id_id", this.infor_storer_id);
        formData.append("variant", this.variant === null ? "" : this.variant);
        formData.append(
          "sku_description",
          this.description === null ? "" : this.description
        );
        formData.append(
          "sku_type",
          this.sku_type === "Add an existing Barcode" ? 1 : 0
        );
        if (this.sku_type === "Add an existing Barcode") {
          formData.append(
            "b2b_barcode",
            this.barcode === null ? "" : this.barcode
          );
        }

        // append each image with its Content-Type header
        if (this.imagesUpload.length > 0) {
          this.imagesUpload.forEach((image) => {
            formData.append(
              "images",
              image,
              `${image.name}`,
              `image/${image.type}`
            );
          });
        }
        if (this.$route.params.id > 0) {
          formData.append("record_id", this.$route.params.id);
          delete formData["storer_id_id"];
          this.updateSkuBB({
            record_id: this.$route.params.id,
            data: formData,
          }).then((res) => {
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$refs.form.reset();
            this.$router.push("/skulist");
          });
        } else {
          this.uploadSkuBB(formData).then((res) => {
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$refs.form1.reset();
            this.getlist();
            if (from == "nomore") {
              this.$router.push("/skulist");
            }
          });
          this.imageUrls = [];
          this.imagesUpload = [];
        }
      }
    },
    reset() {
      this.$refs.form.reset();
      this.$router.push("/skulist");
    },
    checkIcon(item) {
      return this.image_mapping.includes(item.id);
    },

    fetchClientList() {
      if (this.clients.length) return;

      if (this.clients.length === 0 && this.$route.params.id == 0) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
          variant: "1",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.v-img {
  margin-top: 20px;
  margin-top: 20px;
  max-height: 300px;
  max-width: 300px;
  object-fit: cover;
}
.custom-file-input .v-input__icon.v-input__icon--prepend {
  display: none !important;
}
</style>
